<template>
  <v-card :style="{ 'border-color': getCorStatus(registro.status.id) }" @click="emitirClick">
    <v-card-item>
      <div class="box-logo" :style="{ backgroundImage: 'url(' + registro.logo + ')' }"></div>
      <div class="box-status">
        <label class="fonte-reduzida" :style="{ color: getCorStatus(registro.status.id) }">
          Status: {{ registro.status.descricao }}
        </label>
      </div>
      <div class="box-dados">
        <div class="container-nome">
          <label class="fonte-reduzida">{{ registro.empresa }}</label>
          <hr>
          <label class="fonte-reduzida">{{ registro.equipamento.nome }}</label>
        </div>
        <div class="icons-conexao">
          <div class="icone" :class="getClassIcone(registro.equipamento.conectadoRede, true)"></div>
          <div class="icone" :class="getClassIcone(registro.equipamento.conectadoBanco, false)"></div>
        </div>
        <div class="box-alerta">
          <div class="alerta">
            <v-badge class="badge-alarme" :content="registro.equipamento.qtdAlarme" offset-y="-10">
              <font-awesome-icon class="icon-size" :icon="['fas', 'bell']" />
            </v-badge>
            <label class="fonte-reduzida">Alarme</label>
          </div>
          <div class="alerta">
            <v-badge class="badge-trip" :content="registro.equipamento.qtdTrip" offset-y="-10">
              <font-awesome-icon class="icon-size" :icon="['fas', 'bell']" />
            </v-badge>
            <label class="fonte-reduzida">Trip</label>
          </div>
        </div>
        <div class="container-rodape" @click="emitirClickConfiguracoes">
          <div class="icone-config"></div>
        </div>
      </div>
    </v-card-item>
  </v-card>
</template>

<script>
export default {
  props: {
    registro: Object,
  },
  methods: {
    getClassIcone(conectado, rede) {
      return `icone-${rede ? 'rede' : 'db'}-${conectado ? 'on' : 'off'}`;
    },
    getCorStatus(statusId) {
      switch (statusId) {
        case 1:
          return '#6C6C6C !important';
        case 2:
          return '#0CA42E !important';
        case 3:
          return '#8D750D !important';
        default:
          return '#A31010 !important';
      }
    },
    emitirClick() {
      this.$emit('click-action', this.registro.idEquipamento);
    },
    emitirClickConfiguracoes() {
      this.$router.push(`/configurar-variaveis/${this.registro.idEquipamento}`);
    }
  }
};
</script>

<style scoped>
.v-card {
  height: 310px;
  width: 168px;
  border-radius: 10px !important;
  background-color: var(--cor-card-fundo) !important;
  border: 3px solid !important;
}

.v-card:hover {
  transform: scale(1.06);
  box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.3);
  z-index: 9999999;
}

.v-card-item {
  padding: 0px !important;
}

.box-logo {
  width: 310px;
  height: 56px;
  background-size: 168px 56px;
  background-repeat: no-repeat;
}

.logo {
  width: 100%;
  height: 100%;
}

.box-status {
  width: 100%;
  height: 40px;
  background-color: var(--cor-secundaria);
  font-weight: 600;
  font-size: 15px;
  line-height: 14.06px;
  display: flex;
  align-items: center;
  justify-content: center;
}

hr {
  width: 149px;
  border: 1px solid #393850;
}

.box-dados {
  height: 210px;
  width: 98%;
  background-color: var(--branco-fundo);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  padding-top: 10px;

  label {
    width: 90%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: var(--text-color);
  }
}

.container-nome {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.icons-conexao {
  display: flex;
  width: 90%;
  justify-content: flex-end;
  gap: 7px;
  padding-top: 25px;
  padding: 10px 0px 10px 0px;
}

.box-alerta {
  width: 90%;
  display: flex;
  flex-direction: column;
  align-content: flex-start;
  flex-wrap: wrap;
  gap: 20px;
}

.alerta {
  gap: 10px;
  display: flex;
  align-items: center;
}

.container-rodape {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.icone-config {
  background: url("../assets/icon-config.svg") no-repeat center center;
  width: 36px;
  height: 36px;
}

.icone-rede-on {
  background: url("../assets/icon-rede.svg") no-repeat center center;
}

.icone-rede-off {
  background: url("../assets/icon-rede-off.svg") no-repeat center center;
}

.icone-db-on {
  background: url("../assets/icon-db.svg") no-repeat center center;
}

.icone-db-off {
  background: url("../assets/icon-db-off.svg") no-repeat center center;
}

.icone {
  background-size: 20px 20px;
  width: 20px;
  height: 20px;
}

.badge-alarme ::v-deep(.v-badge__badge) {
  background: #8D750D !important;
}

.badge-trip ::v-deep(.v-badge__badge) {
  background-color: #A31010 !important;
}

@media screen and (max-width: 640px) {
  .v-card {
    width: 75vw;
  }

  .box-logo {
    background-size: 100px 56px;
    background-color: white;
  }

  hr {
    width: 90%;
  }

  .box-alerta {
    height: 55px;
    flex-wrap: nowrap;
    flex-direction: row;
    align-items: flex-end;
    justify-content: space-between;
    width: 65%;
  }

  .fonte-reduzida {
    font-size: 16px;
  }
}
</style>
